// TODO: create not found page
export function NotFoundPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold text-red-500">Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}
